// Services
import apiService from "services/apiService";

const loadRidingProjections = async () => {
  const response = await fetch(apiService.apiURL("riding_projections"));
  return await response.json();
};

export default {
  loadRidingProjections,
};
